var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 11V5H0V3h1V2a2 2 0 0 1 2-2h8a2 2 0 0 1 1.733 1H14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1.267A2 2 0 0 1 11 16H3a2 2 0 0 1-2-2v-1H0v-2zm1 2h1v-2H2V5h1V3H2V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM13 2v12h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
  clipRule: "evenodd"
})));
export default SvgReportsIcon;